import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultFilter: '=',
        filter: '=',
        hasActiveUsers: '=',
        tmsView: '='
    },
    template: `
        <div class="table-filters">
            <form ng-submit="vm.applyFilter()" class="form form-filter">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Name' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.name" class="form-control">
                        </div>
                    </div>
                    <div ng-if="vm.tmsView" class="row">
                        <span class="label">{{ 'filter.Only company managers' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" name="switch" ng-model="vm.companyManagersOnly">
                                 <span>Yes</span>
                            </label>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li>
                        <input ng-click="vm.resetFilter()" type="button" class="btn discrete"
                        value="{{ 'filter.Reset' | translate }}">
                    </li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor (lodash, USER_STATUS_ENUM, UserService) {
        this.lodash = lodash;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.UserService = UserService;
    }

    applyFilter () {
        if (this.companyManagersOnly) {
            this.filter.companyManagersOnly = true;
        }
        else {
            delete this.filter.companyManagersOnly;
        }
        this.list.fetch(this.filter).then((users) => {
            this.hasActiveUsers = users.filter((user) => this.UserService.isActive(user)).length;
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.companyManagersOnly = false;
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/users/filter/index.js